import type { IResponseApi } from '@/modules/Core/interfaces'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfPlanes } from '@/modules/Configuracion/interfaces'
import type { AxiosResponse } from 'axios'

export class PlanesService extends BaseService<IConfPlanes> {
  constructor () {
    super({ baseUrl: 'system/planes/' })
  }

  async asignarPlan (coplNombre: string): Promise<AxiosResponse<IResponseApi<boolean>>> {
    return this.http.post<boolean>('/asignar', { coplNombre }).catch(this.errorHandle)
  }

  async savePlan (payload: { coplNombre: string; coplNombreAnterior?: string; items: Partial<IConfPlanes>[] }): Promise<AxiosResponse<IResponseApi<boolean>>> {
    return this.http.post<boolean>('/save-plan', payload).catch(this.errorHandle)
  }

  async getNombres (): Promise<AxiosResponse<IResponseApi<string[]>>> {
    return this.http.get<string[]>('/nombres').catch(this.errorHandle)
  }

  async deleteByNombre (coplNombre: string): Promise<AxiosResponse<IResponseApi<boolean>>> {
    return this.http.delete<boolean>('/delete-by-nombre', { data: { coplNombre } }).catch(this.errorHandle)
  }

  async getGeneral (): Promise<AxiosResponse<IResponseApi<{ eventos: string[] }>>> {
    return this.http.get<IResponseApi<{ eventos: string[] }>>('/general').catch(this.errorHandle)
  }
}
